import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Cookies from "js-cookie";

const ConfirmModal = ({ show, handleClose, handleProceed, confirmMessage }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <b>
            <i className="fas fa-exclamation-triangle"></i> Please confirm
          </b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{confirmMessage}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn btn-black btn-lg w-100"
          onClick={handleProceed}
        >
          Yes, proceed <i className="fas fa-arrow-right"></i>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
